import { AxiosInstance } from "axios"
import { CustomJob } from "../../../../merchant/accounting/accounting/merchantCustomReports/customReportsTypes"

export enum CompanySettingsCustomJobQuery {
    CUSTOM_JOBS_LIST = "custom-jobs-list-for-company",
}

type FetchCustomJobsParams = Readonly<{
    companyId: number
    type?: string
}>

export type FetchCustomJobsResponse = Readonly<{
    customJobs: Array<CustomJob>
}>

export async function fetchCustomJobs(
    params: FetchCustomJobsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchCustomJobsResponse> {
    const { companyId, ...rest } = params

    const url = `/companies/${companyId}/settings/customJobs`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}
